<template>
  <div>
    <div>
      <vxe-grid
        ref="table"
        show-overflow
        highlight-hover-row
        :data="tableData"
        :height="300"
        :columns="tableColumns"
        :toolbar-config="tableToolbar"
        :edit-rules="validRules"
        row-key
        size="small"
        auto-resize
        resizable
        border
        :edit-config="{ trigger: 'click', mode: 'row' }"
      >
        <template v-slot:toolbar_form>
          <slot name="header">
            <div class="side-frame-warning">
              <el-button
                type="primary"
                icon="el-icon-plus"
                size="small"
                @click="add()"
                >{{ $l('INDEX.product_dialog_btn_add') || '添加' }}</el-button
              >
              <el-button
                type="danger"
                icon="el-icon-delete"
                size="small"
                @click="$refs.table.removeCheckboxRow()"
                >{{ $l('INDEX.btn_tips_del') || '删除' }}</el-button
              >
            </div>
          </slot>
        </template>
      </vxe-grid>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    identifyJson: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      tableData: [],
      formData: { identifyNo: '' },
      validRules: {
        identifyNo: [
          {
            required: true,
            pattern: /^.{0,50}$/,
            message:
              this.$l('INDEX.form_label_must_input') ||
              '识别码编号必须填写且长度小于等于50',
          },
        ],
        identifyCodeType: [
          {
            required: true,
            message:
              this.$l('INDEX.form_label_pe_identifyCodeType') ||
              '请输入识别码类型',
          },
        ],
      },
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
      },
      tableColumns: [
        {
          field: 'seq',
          width: 40,
          align: 'center',
          fixed: 'left',
          type: 'seq',
        },
        {
          width: 50,
          align: 'center',
          fixed: 'left',
          type: 'checkbox',
        },
        {
          field: 'identifyCodeType',
          headerAlign: 'center',
          align: 'center',
          minWidth: 150,
          title: this.$l('INDEX.form_label_identifyCodeType') || '识别码类型',
          required: 'validRules',
          editRender: {
            name: 'dict-select',
            props: {
              default: true,
              filterable: true,
              placeholder:
                this.$l('INDEX.form_label_pe_identifyCodeType') ||
                '请输入识别码类型',
              body: { dictType: 'identifyCodeType' },
              url: '/master/common/dict/biz',
            },
          },
        },
        {
          field: 'identifyNo',
          headerAlign: 'center',
          align: 'center',
          minWidth: 150,
          title: this.$l('INDEX.form_label_identifyNo') || '识别码编号',
          editRender: {
            name: 'input',
            attrs: {
              type: 'text',
              placeholder:
                this.$l('INDEX.form_label_pe_identifyNo') || '请输入识别码编号',
            },
          },
        },
      ],
    }
  },
  watch: {
    identifyJson: {
      handler(val) {
        if (val) this.tableData = JSON.parse(val)
      },
      immediate: true,
    },
  },

  methods: {
    async add(row) {
      const $table = this.$refs.table
      const { row: newRow } = await $table.insertAt({}, row)
      await $table.setActiveCell(newRow, 'identifyCodeType')
    },
    getTableData() {
      const { tableData } = this.$refs.table.getTableData()

      tableData.sort(this.comparisonFunction('identifyCodeType'))
      return tableData.map((row) => {
        return {
          identifyNo: row.identifyNo,
          identifyCodeType: row.identifyCodeType,
          identifyCodeTypeText: row.identifyCodeTypeText,
        }
      })
    },
    comparisonFunction(propertyName) {
      return function(obj1, obj2) {
        var val1 = obj1[propertyName]
        var val2 = obj2[propertyName]
        if (val1 < val2) {
          return -1
        } else if (val1 > val2) {
          return 1
        } else {
          return 0
        }
      }
    },

    async validEvent() {
      const $table = this.$refs.table
      //表格校验必填项
      const errMap = await $table.validate(true)
      if (errMap) {
        return false
      } else {
        //校验识别码类型是否重复
        const { tableData } = $table.getTableData()
        const newArr = tableData.map((item) => item.identifyCodeType)
        const arrSet = new Set(newArr)
        if (arrSet.size === newArr.length) return true
        this.$message.warning(
          this.$l('INDEX.form_label_identifyCodeType_repeat') ||
            '识别码类型重复请检查后保存!'
        )
        return false
      }
    },
  },
}
</script>
